module.exports = {"320921100":"响水镇","320921101":"陈家港镇","320921102":"小尖镇","320921103":"黄圩镇","320921104":"大有镇","320921105":"双港镇","320921106":"南河镇","320921107":"运河镇","320921400":"县开发区","320921401":"省属黄海农场","320921402":"省属灌东盐场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320921.json
// module id = 1007
// module chunks = 0